import { render } from "./UserEditUnit.vue?vue&type=template&id=17972281&scoped=true"
import script from "./UserEditUnit.vue?vue&type=script&lang=js"
export * from "./UserEditUnit.vue?vue&type=script&lang=js"

import "./UserEditUnit.vue?vue&type=style&index=0&id=17972281&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17972281"]])

export default __exports__